export default __webpack_public_path__ + "static/media/it-ht.28285a6f.svg";